import StageBackgroundComponent from './StageBackground';
import StageBackgroundContainer from './StageBackground.container';
export default StageBackgroundContainer(StageBackgroundComponent);

//# sourceMappingURL=index.js.map